// Third-party
import { useMemo } from 'react';

// RTK Query
import { useGetPlanForContactQuery } from '@/redux/api/planning';

// Utils
import { filterImportedAccounts } from '@/utils/planning';

// Types
import { Account, Plan } from '@/types/planning';
import Contact from '@/types/contact';

interface UseContactPlanAccountsProps {
  contact?: Contact;
  selectedPlanAccountId?: string;
  skip?: boolean;
}

interface UseContactPlanAccountsReturn {
  planId?: string;
  plan?: Plan;
  importedAccounts: Account[];
  selectedAccount: Account | undefined;
  isLoading: boolean;
  error: any;
}

export const useContactPlanAccounts = ({ contact, selectedPlanAccountId, skip }: UseContactPlanAccountsProps): UseContactPlanAccountsReturn => {
  const contactId = contact?._id || '';

  const {
    data: plan,
    isLoading,
    error,
  } = useGetPlanForContactQuery(contactId, {
    skip: skip || !contactId,
  });

  const importedAccounts = useMemo(() => (plan?.accounts ? filterImportedAccounts(plan.accounts) : []), [plan?.accounts]);

  const selectedAccount = useMemo(() => {
    if (!selectedPlanAccountId || !importedAccounts.length) {
      return undefined;
    }
    return importedAccounts.find(account => account._id === selectedPlanAccountId);
  }, [importedAccounts, selectedPlanAccountId]);

  return {
    planId: plan?._id,
    plan,
    importedAccounts,
    selectedAccount,
    isLoading,
    error,
  };
};
